export const DestinationCommandeLabels = {
    NONE: "—",
    RECLAMATION: "Réclamation"
};

export const DestinationCommandeValues = Object.fromEntries(
    Object.entries(DestinationCommandeLabels).map(([key, label]) => [key, key])
);